/* Ecochic · Cross-sell de la ficha (FLUJO_FRONTEND_ECOCHIC_v1 §2, reglas 20-25; web-v3 catalogo.js crossSellHTML).
   1) «Completa tu rutina»: otros pasos de la rutina del perfil; sin perfil, misma marca y otro tipo.
   2) «Alternativas para tu piel»: mismo tipo; con perfil, ideal/apto primero (defecto 2 del anexo corregido).
   Nunca un producto «No apto» (avoid). Textos: ajustes de la sección. */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function eur(v) { var n = parseFloat(v); return (isNaN(n) || n === 0) ? '' : n.toFixed(2).replace('.', ',') + ' €'; }
  function P_() { return window.Eco && Eco.Profile; }
  function personalized() { try { return !!(P_() && P_().personalized()); } catch (e) { return false; } }
  function ecoP(p) {
    try {
      var ex = (window.PRODUCTS_EXTRA || {})[p.h] || {};
      return Eco.data.toP({ handle: p.h, title: p.t, description: p.desc, product_type: p.product_type, tags: p.tags,
        custom: { inci: p.inci, activos_clave: ex.activos || [], tipos_piel: ex.piel || [] } });
    } catch (e) { return null; }
  }
  function fitLevel(p) { try { return (P_().fitStatus(ecoP(p)) || {}).level || 'none'; } catch (e) { return 'none'; } }
  function fitTag(p) { try { return Eco.fitTag(ecoP(p), true) || ''; } catch (e) { return ''; } }

  function mount(root) {
    var C = {};
    try { C = JSON.parse(root.querySelector('[data-eco-xsell-config]').textContent) || {}; } catch (e) {}
    var lim = C.limit || 3;
    function card(p) {
      var price = eur(p.price), tag = fitTag(p);
      return '<a class="ec-card" href="' + esc(p.u || (ROOT + 'products/' + p.h)) + '">' +
        '<span class="ec-img">' + (tag ? '<span class="ec-tag">' + tag + '</span>' : '') +
          (p.img ? '<img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.t) + '">' : '') + '</span>' +
        '<span class="ec-body"><span class="ec-brand">' + esc(p.brand || C.brand_fallback || '') + '</span>' +
          '<span class="ec-name">' + esc(p.t) + '</span>' +
          '<span class="ec-foot">' + (price ? '<span class="ec-price">' + price + '</span>' : '<span class="ec-price ec-muted">' + EcoT('core.consultar') + '</span>') +
          '<span class="ec-seal">' + (p.ok === true ? EcoT('core.sello_corto') : '·') + '</span></span></span></a>';
    }
    function show(key, list, sub) {
      var box = root.querySelector('[data-eco-xsell="' + key + '"]'); if (!box) return;
      if (!list.length) { box.hidden = true; return; }
      box.querySelector('[data-eco-xsell-sub]').textContent = sub || '';
      box.querySelector('[data-eco-xsell-grid]').innerHTML = list.map(card).join('');
      box.hidden = false;
    }
    function render() {
      var ALL = (window.PRODUCTS || []).filter(function (q) { return !(window.ECO_DATA && ECO_DATA.isService(q.h)); });
      var p = window.EcoCatalog.byHandle(C.handle); if (!p) return;
      var seen = {}; seen[p.h] = 1;
      function ok(q) { return q && q.h && !seen[q.h] && q.available !== false && fitLevel(q) !== 'avoid'; }
      var compl = [], sub = '';
      try {
        var r = window.EcoRoutines && EcoRoutines.buildForProfile ? EcoRoutines.buildForProfile() : null;
        if (r && r.steps) r.steps.forEach(function (s) { var q = s && s.product && window.EcoCatalog.byHandle(s.product.h); if (!ok(q) || q.type === p.type) return; seen[q.h] = 1; compl.push(q); });
        if (compl.length) sub = C.compl_sub_profile;
      } catch (e) {}
      if (!compl.length) {
        ALL.forEach(function (q) { if (compl.length >= lim || !ok(q)) return; if (p.brand && q.brand === p.brand && q.type !== p.type) { seen[q.h] = 1; compl.push(q); } });
        if (compl.length) sub = String(C.compl_sub_brand || '').replace('[marca]', p.brand || C.brand_fallback || '');
      }
      show('compl', compl.slice(0, lim), sub);
      var rank = { ideal: 0, apt: 1, caution: 2, none: 3 };
      var alts = ALL.filter(function (q) { return ok(q) && q.type === p.type; });
      if (personalized()) alts.sort(function (a, b) { return (rank[fitLevel(a)] != null ? rank[fitLevel(a)] : 3) - (rank[fitLevel(b)] != null ? rank[fitLevel(b)] : 3); });
      show('alt', alts.slice(0, lim), personalized() ? C.alt_sub_profile : C.alt_sub);
    }
    window.EcoCatalog.load('all').then(function () {
      render();
      try { P_().on(render); } catch (e) {}
    }, function () {});
  }
  function init() {
    if (!window.EcoCatalog) return;
    [].forEach.call(document.querySelectorAll('.jm-section-eco-xsell'), mount);
  }
  (function boot(n) { if ((window.Eco && window.EcoCatalog) || n > 200) init(); else setTimeout(function () { boot(n + 1); }, 30); })(0);
})();
